module.exports = __webpack_public_path__ + "img/logo.c2b323d6.png";